import { useState, useEffect, useCallback, useContext } from "react";
import {
  fetchProjects,
  fetchMyProjects,
  deleteProject,
} from "../api/ProjectsAPI";
import { message } from "antd";
import { AuthContext } from "../../../services/authcontext";

export default function useProjects(isManager) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user: userData } = useContext(AuthContext);

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      if (isManager) {
        const all = await fetchProjects();
        const transformed = (all || []).map((project) => ({
          id: project.id,
          title: project.title,
          description: project.description,
          status: project.status,
          progress: project.progress,
          created: project.createdAt,
          owner: project.owner,
          collaborators: project.collaborators,
          modules: project.modules,
          projectType:
            project.owner?.id === userData.id ? "owned" : "collaborating",
        }));
        setData(transformed);
      } else {
        const myData = await fetchMyProjects();
        setData([
          ...(myData?.myCreatedProjects || []),
          ...(myData?.collaboratingProjects || []),
        ]);
      }
    } catch (err) {
      message.error({
        content: "Failed to load projects",
        key: "load-projects-error",
      });
    } finally {
      setLoading(false);
    }
  }, [isManager, userData]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const removeProject = async (id) => {
    try {
      await deleteProject(id);
      message.success("Project deleted successfully");
      loadData();
    } catch {
      message.error("Failed to delete project");
    }
  };

  return { data, loading, loadData, removeProject };
}
